import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = {
  key: 2,
  class: "file-icon-wrapper"
}

import {computed, inject} from 'vue';
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";
import ChatTag from "~/chat/vue/misc/ChatTag.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import {LightboxInjection} from "~/core-ui/ts/LightboxInjection";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";


const __default__ = {
    name: "ChatAttachList"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    attachments: {}
  },
  setup(__props: any) {

let props = __props;

let lightbox = inject(LightboxInjection, null);

let textareaDesign = computed(() => {
    return ConfigStore.design.value.dialog.textarea;
});

let hasImages = computed(() => !!props.attachments.find(item => item.isImage));

function openUrl(url: string) {
    window.open(url);
}

return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_ctx.attachments.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_TransitionGroup, {
          name: "list",
          tag: "span"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (item, index) => {
              return _withDirectives((_openBlock(), _createBlock(ChatTag, {
                key: item.id,
                onClose: ($event: any) => (_ctx.attachments.splice(index, 1)),
                class: _normalizeClass({
                    'is-image': item.isImage,
                    'has-images': _unref(hasImages) && !item.isImage
                }),
                style: _normalizeStyle(`border: 1px solid ${_unref(textareaDesign).controlsColor} !important`)
              }, {
                default: _withCtx(() => [
                  (!_unref(hasImages))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(item.filename), 1)
                      ], 64))
                    : (item.isImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: item.finalUrl,
                          class: "img",
                          onClick: _withModifiers(($event: any) => (_unref(lightbox)(item.finalUrl)), ["stop"])
                        }, null, 8, _hoisted_2))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(SvgIcon, {
                            class: "file-icon",
                            "icon-name": "file",
                            "icon-style": "light"
                          }),
                          _createTextVNode(" " + _toDisplayString(item.filename), 1)
                        ]))
                ]),
                _: 2
              }, 1032, ["onClose", "class", "style"])), [
                [_directive_on_native, () => openUrl(item.finalUrl), "click"]
              ])
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})